import { resolveAccessCredentials, selectModals, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

import DialogAccessCredentials from './DialogAccessCredentials';
import type { IAccessCredentialsMetadata } from './DialogAccessCredentials.helpers';

const DialogAccessCredentialsContainer = () => {
	const modals = useAppSelector(selectModals);
	const dispatch = useAppDispatch();

	const accessCredentialsModal = modals.find((i) => i.id === 'accessCredentials');
	const metadata = accessCredentialsModal?.metadata as IAccessCredentialsMetadata | undefined;

	const dispatchAccessCredentials = useCallback(
		(code?: string) => {
			if (metadata?.verificationId && code) {
				dispatch(resolveAccessCredentials({ verificationId: metadata.verificationId, code }));
			}
		},
		[dispatch, metadata?.verificationId]
	);

	if (!metadata) return null;

	const { mode, type, title, description, inputLength } = metadata;

	return (
		<DialogAccessCredentials
			mode={mode}
			type={type}
			description={description}
			dispatchAccessCredentials={dispatchAccessCredentials}
			title={title}
			inputLength={inputLength}
		/>
	);
};

export default DialogAccessCredentialsContainer;
